import React from "react";
import { Link } from "react-router-dom";

/**
 * Typography-only brand (no template logo).
 * variant: sidebar — stacked; header — single line; compact — for tight horizontal layouts
 */
const BrandWordmark = ({
  variant = "header",
  asLink = true,
  className = "",
  collapsed = false,
}) => {
  const inner =
    variant === "sidebar" && collapsed ? (
      <div
        className={`font-jakarta flex justify-center ${className}`}
        title="MySway Backoffice"
      >
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-600 text-sm font-bold tracking-tight text-white shadow-sm ring-1 ring-teal-500/30">
          M
        </span>
      </div>
    ) : variant === "sidebar" ? (
      <div className={`font-jakarta ${className}`}>
        <div className="text-[1.1rem] font-semibold tracking-[-0.03em] text-slate-900 dark:text-white leading-none">
          mysway
        </div>
        <div className="mt-1 text-[0.58rem] font-semibold uppercase tracking-[0.18em] text-teal-600 dark:text-teal-400">
          backoffice
        </div>
      </div>
    ) : variant === "compact" ? (
      <div
        className={`font-jakarta flex items-baseline gap-1.5 flex-wrap ${className}`}
      >
        <span className="text-lg font-semibold tracking-tight text-slate-900 dark:text-white">
          mysway
        </span>
        <span
          className="text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-teal-600 dark:text-teal-400"
          aria-hidden
        >
          ·
        </span>
        <span className="text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-teal-600 dark:text-teal-400">
          backoffice
        </span>
      </div>
    ) : (
      <div
        className={`font-jakarta flex items-baseline gap-2.5 flex-wrap ${className}`}
      >
        <span className="text-xl sm:text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">
          mysway
        </span>
        <span className="hidden sm:inline text-slate-300 dark:text-slate-600 select-none">
          /
        </span>
        <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-teal-600 dark:text-teal-400">
          backoffice
        </span>
      </div>
    );

  if (!asLink) return inner;

  return (
    <Link
      to="/dashboard"
      className="inline-block outline-none rounded-lg focus-visible:ring-2 focus-visible:ring-teal-500/60 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900"
    >
      {inner}
    </Link>
  );
};

export default BrandWordmark;
